export default __webpack_public_path__ + "static/15-501ecddd98edf454141aeef2da30d143.jpg";